import React, { useRef } from "react";
import { Plan2PlateIconButton } from "./buttons/Plan2PlateIconButton";
import { scan, scanLabel, scanPurchaseLabel } from "../api";
import Food from "../data/food";
import { plan2plateIcons } from "../utils/iconUtils";
import { Purchase } from "../data/purchase";
import { SmallIconButton } from "./SmallIconButton";

function ImageScanner(props: {
  icon: keyof typeof plan2plateIcons;
  fileScanned: (file: File) => void | Promise<void>;
  dataCy?: string;
}) {
  const inputRef = useRef<HTMLInputElement>(null);
  return (
    <>
      <SmallIconButton
        data-cy={props.dataCy}
        icon={props.icon}
        label={props.icon}
        onClick={() => inputRef.current?.click()}
      />
      <input
        ref={inputRef}
        className="hidden"
        type="file"
        capture="environment"
        onChange={async (e) => {
          const files = e.target.files;
          if (files) {
            for (let i = 0; i < files.length; i++) {
              const file = files.item(i);
              if (file) {
                props.fileScanned(file);
              }
            }
          }
        }}
      />
    </>
  );
}

export const LabelScanner = (props: {
  onLabelScan?: (value: Food) => void;
  dataCy?: string;
}) => {
  return (
    <ImageScanner
      dataCy={props.dataCy}
      icon={"clipboardImage"}
      fileScanned={async (file) => {
        const result = (await scanLabel({ body: { file } })).data;
        props.onLabelScan && props.onLabelScan(result);
      }}
    />
  );
};

export const PurchaseLabelScanner = (props: {
  onLabelScan?: (value: Purchase) => void;
  dataCy?: string;
}) => {
  return (
    <ImageScanner
      dataCy={props.dataCy}
      icon={"clipboardImage"}
      fileScanned={async (file) => {
        const result = (await scanPurchaseLabel({ body: { file } })).data;
        props.onLabelScan && props.onLabelScan(result);
      }}
    />
  );
};

export const BarcodeScanner = (props: {
  onBarcodeScan?: (value: number | undefined) => void;
  dataCy?: string;
}) => {
  return (
    <ImageScanner
      dataCy={props.dataCy}
      icon={"barcode"}
      fileScanned={async (file) => {
        const result = (await scan({ body: { file } })).data;
        const eanNumber = Number(result);
        const ean = isNaN(eanNumber) ? undefined : eanNumber;
        props.onBarcodeScan && props.onBarcodeScan(ean);
      }}
    />
  );
};
